(() => {
  'use strict';
  const script = document.currentScript;
  if (!script || window.Shopify?.designMode || window.top !== window.self) return;
  if (document.documentElement.hasAttribute('data-smk-cart-return-started')) return;
  document.documentElement.setAttribute('data-smk-cart-return-started', '');
  const key = 'suimok.cart-return.v1';
  const ttl = 120000;
  const current = new URL(window.location.href);
  const path = value => value.replace(/\/$/, '') || '/';
  let root, cart;
  try {
    root = new URL(script.dataset.rootUrl, current);
    cart = new URL(script.dataset.cartUrl, current);
    if (root.origin !== current.origin || cart.origin !== current.origin) return;
    if (path(root.pathname) === path(cart.pathname)) return;
  } catch (_) { return; }
  const preview = current.searchParams.get('preview_theme_id');
  if (preview && preview !== script.dataset.themeId) return;
  if (preview) {
    root.searchParams.set('preview_theme_id', preview);
    cart.searchParams.set('preview_theme_id', preview);
  }
  const shopPayReturn = current.searchParams.getAll('logged_in').length === 1 && current.searchParams.get('logged_in') === 'true';
  if (shopPayReturn) {
    root.searchParams.set('logged_in', 'true');
    cart.searchParams.set('logged_in', 'true');
  }
  if (script.dataset.pageType === 'cart' && path(current.pathname) === path(cart.pathname)) {
    if (current.hash || [...current.searchParams.keys()].some(name => name !== 'preview_theme_id' && !(name === 'logged_in' && shopPayReturn))) return;
    try {
      const value = JSON.stringify({version: 1, at: Date.now(), theme: script.dataset.themeId});
      window.sessionStorage.setItem(key, value);
      if (window.sessionStorage.getItem(key) !== value) return;
      window.location.replace(root.href);
    } catch (_) {
      try { window.sessionStorage.removeItem(key); } catch (_) {}
    }
    return;
  }
  if (script.dataset.pageType !== 'index' || path(current.pathname) !== path(root.pathname)) return;
  let intent;
  try {
    const stored = window.sessionStorage.getItem(key);
    window.sessionStorage.removeItem(key);
    intent = JSON.parse(stored);
  } catch (_) { return; }
  if (!intent || intent.version !== 1 || intent.theme !== script.dataset.themeId ||
      !Number.isSafeInteger(intent.at) || Date.now() < intent.at || Date.now() - intent.at > ttl) return;
  cart.searchParams.set('smk_cart_fallback', '1');
  const fallback = () => window.location.replace(cart.href);
  const open = async () => {
    let timeout;
    try {
      await Promise.race([
        window.customElements.whenDefined('cart-notification'),
        new Promise((_, reject) => { timeout = window.setTimeout(() => reject(new Error('drawer-unavailable')), 5000); })
      ]);
      const drawer = document.querySelector('cart-notification');
      const trigger = document.getElementById('cart-icon-bubble');
      if (!drawer || !trigger || typeof drawer.openCart !== 'function' || typeof drawer.setActiveElement !== 'function') return fallback();
      drawer.setActiveElement(trigger);
      await drawer.openCart(cart.href);
    } catch (_) { fallback(); }
    finally { window.clearTimeout(timeout); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', open, {once: true});
  else open();
})();
